import React, { useContext, useState } from "react";
import classes from "./Navbar.module.scss";
import SettingsSuggestOutlinedIcon from '@mui/icons-material/SettingsSuggestOutlined';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ChangeOrgModal from "./ChangeOrgModal";
import CreateOrgModal from "./CreateOrgModal";
import { useTranslation } from 'react-i18next';
import { DDD } from "../../lib/ddd/ddd";
import { Hourglass } from "react-loader-spinner";
import { NotificationManager} from 'react-notifications';
import { OrgIdContext, ClientTypes } from "../../store/orgId_context";
import { BaseContext } from "../../store/basepath";

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";
const ddd = new DDD(apiRequestAddress);

const SessionInfo = ({ person, company, className,isDemo }) => {
  const [changeOrgPopup, setChangeOrgPopup] = useState(false);
  const [changeOrgVisible, setChangeOrgVisible] =  useState(false);
  const [createOrgPopup, setCreateOrgPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(1);
  const { t } = useTranslation();
  const { clientType, customerRelation, aboutOrgId, mainOrgId, sessionInfo, isMaintainer } = useContext(OrgIdContext);
  const { basepath } = useContext(BaseContext);

  const onChangeOrgPopupClick = () => {
    setChangeOrgPopup(true);
  }

  const onChangeOrgHidden = (val) => {
    //if(clientType === ClientTypes.ISV || clientType === ClientTypes.Company)
    if(clientType !== null && clientType !== undefined || isMaintainer)
      setChangeOrgVisible(true);
  }

  const onCreateNewCompanyClick = () => {
    setChangeOrgPopup(false);
    setCreateOrgPopup(true);
  }

  const onNewCompanyCreated = (data, connectionKey) => {
    setCreateOrgPopup(false);
    setLoading(true);
    NotificationManager.info(t("Please wait while we create new company"), t("Creating new company"));
    let taxId = data["CustomerVatNum"];
    if(!taxId || taxId==="") taxId = data["CustomerTaxNum"];

    const intervalId = setInterval(() => {
      ddd.Rpc_ExecuteMethod("Auth.FindOrganization", {taxid : taxId}).then((res) => {
        if(res?.result){
          clearInterval(intervalId);
          setLoading(false);
          onNewlyCompanyFound(data, connectionKey);
        }
      });
    }, 3000);
  }

  const onNewlyCompanyFound = (data, connectionKey) => {
    NotificationManager.success(data["CustomerName"], t("Company created"));
    setRefresh(val => val+1);
  }

  return (
    <div className={className}>
      <span className={classes["session-details"]}>{person}</span>
      <br />
      <span className={classes["session-details-in"]}>in{" "}</span>
      <span className={classes["session-details"]}>
        {company}{isDemo && <span style={{color:"green"}}>[DEMO]</span>}
        {changeOrgVisible && basepath !== "mycompany" &&
          <OverlayTrigger placement="bottom" overlay={<Tooltip>{t("Change organization")}</Tooltip>}>
            <SettingsSuggestOutlinedIcon className={classes["change-org-icon"]} onClick={onChangeOrgPopupClick}/>
          </OverlayTrigger>
        }
        {loading && <Hourglass height="1rem" width="1rem" colors={['#005683', '#df511d']}/>}
        <ChangeOrgModal show={changeOrgPopup} onHide={() => setChangeOrgPopup(false)} onHiddenChange={onChangeOrgHidden} onAddNewCompany={onCreateNewCompanyClick} reload={refresh}/>
        <CreateOrgModal show={createOrgPopup} onHide={() => setCreateOrgPopup(false)} onAddNewCompany={onNewCompanyCreated}/>
      </span>
    </div>
  );
};

export default SessionInfo;
